import { useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import SearchInput from '@/components/SearchInput';
import Spinner from '@/components/Spinner';
import { useShallowEqualSelector } from '@/hooks';
import { clearFolders, setSearchFolder } from '@/store/myDocuments';
import { fetchFolders } from '@/store/myDocuments/thunks';
import { showError } from '@/utils';

import EmptySection from './EmptySection';
import List from './FolderList/List';

function FolderSection({ section }) {
	const { t } = useTranslation();
	const dispatch = useDispatch();

	const [isEmpty, setIsEmpty] = useState('');
	const { total, isLoading, isCompleted } = useShallowEqualSelector(
		({ myDocuments }) => ({
			total: myDocuments.foldersCount,
			isLoading: myDocuments.fetchFolders.loading,
			isCompleted: myDocuments.fetchFolders.completed
		})
	);

	useEffect(() => {
		dispatch(fetchFolders()).unwrap().catch(showError);

		return () => {
			dispatch(clearFolders());
		};
	}, []);

	useEffect(() => {
		if (!isCompleted) {
			return;
		}

		setIsEmpty(!total);
	}, [isCompleted, total]);

	return (
		<div className="relative flex min-h-[120px] w-full flex-col gap-2 md:min-h-[128px] md:gap-4">
			<h2 className="text-xs font-semibold leading-5">
				{t(`myDocuments.${section}.title`)}
			</h2>
			{isLoading && (
				<Spinner
					className="absolute inset-x-0 top-[96px] z-10 mx-auto text-black md:top-[104px]"
					size={40}
				/>
			)}
			{isEmpty ? (
				<EmptySection section={section} className="py-5" />
			) : (
				<div className="flex flex-col gap-3 md:gap-4">
					<SearchInput
						name="search"
						className="w-[226px]"
						onChange={e => dispatch(setSearchFolder(e.target.value))}
						placeholder={t('myDocuments.search')}
					/>
					<List />
				</div>
			)}
		</div>
	);
}

export default FolderSection;
